import { useDropdown } from '@calendly/ui/components/dropdown'

import { ContentBody } from './components/content_body'
import { EventTypeSelectControl } from './components/utils'
import { Options, StyledSelectUI } from './styles'


export const EventTypeSelect = ({
  ownerType,
  disabled,
  placeholder,
  onChange,
  handleSelectAll,
  handleClearAll,
  eventTypes,
  handleFetchMoreEvents,
  actualSelectedCount,
  isWide,
}) => {
  const [toggleDropdown, Dropdown, isExpanded] = useDropdown()

  const handleEventTypeCount = () => {
    let total = 0
    eventTypes.forEach((eventType) => {
      const count = eventType.pagination?.totalCount ?? eventType.items.length
      total += count
    })
    return [actualSelectedCount, total]
  }

  return (
    <StyledSelectUI data-component="mi-event-type-select" isWide={isWide}>
      <EventTypeSelectControl
        disabled={disabled}
        isExpanded={isExpanded}
        onClick={toggleDropdown}
        ownerType={ownerType}
        placeholder={placeholder}
        count={handleEventTypeCount()[0]}
        total={handleEventTypeCount()[1]}
      />
      <Dropdown>
        <Options
          id="mi-event-type-select-popup"
          role="dialog"
        >
          <ContentBody
            eventTypes={eventTypes}
            onChange={onChange}
            handleSelectAll={handleSelectAll}
            handleClearAll={handleClearAll}
            handleFetchMoreEvents={handleFetchMoreEvents}
          />
        </Options>
      </Dropdown>
    </StyledSelectUI>
  )
}
